module.exports = __webpack_public_path__ + "static/media/bkash.7681d4d8.svg";